/* eslint-disable */
import { finish, error } from '../../../modules/bets/actions/query';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

export function request(dispatch, { id, query }) {
    const q = {
        perPage: 10,
    };

    if (query.event) {
        q['leg.event'] = query.event;
    }

    if (query.searchBy === 'eventId' && query.searchByIdValue) {
        q['leg.event'] = {
            in: [query.searchByIdValue],
        };
    }

    if (query.searchBy === 'betId' && query.searchByIdValue) {
        q['betId'] = {
            in: [query.searchByIdValue],
        };
    }

    if (query['betType[EW]']) {
        q['eachWay'] = {
            eq: true,
        };
        query['betType[EW]'] = false;
    }

    if (query.page) {
        q.page = query.page;
    }

    if (query.sort) {
        q.sort = query.sort;
    }

    if (query.perPage) {
        q.perPage = query.perPage;
    }

    if (query.summary) {
        q.aggregations = {
            total: {
                type: 'count',
            },
            totalProfitLoss: {
                type: 'sum',
                field: 'operatorProfit',
            },
            totalStake: {
                type: 'sum',
                field: 'operatorTotalStake',
            },
            averageStake: {
                type: 'avg',
                field: 'operatorTotalStake',
            },
        };
    } else {
        q.aggregations = {
            total: {
                type: 'count',
            },
        };
    }

    // Date (placement / settlement)
    if (query.range) {
        const date = {
            gte: query.range.startDate,
            lte: query.range.endDate,
        };

        if (query.type === 'placement') {
            q.placedAt = date;
        } else {
            q.settledAt = date;
        }
    }

    // New Trading Selection ID
    if (query.selection) {
        q.selection = parseInt(query.selection, 10);
    }

    // Account ID
    if (query.accountId) {
        q['account.id'] = {
            eq: parseFloat(query.accountId),
        };
    }

    if (query.freebet) {
        q['freebet'] = {
            eq: query.freebet,
        };
    }

    // Cashed out
    if (query.cashedOut && query.cashedOut !== 'both') {
        q['cashOut'] = {
            eq: query.cashedOut === 'yes',
        };
    }

    // Settle type
    if (query.settleType && query.settleType !== ' ') {
        q['settleType'] = {
            eq: query.settleType,
        };
    }

    // In play
    if (query.inPlay && query.inPlay !== 'both') {
        q['leg.inPlay'] = {
            eq: query.inPlay === 'yes',
        };
    }

    // Status
    const statuses = Object.keys(query)
        .filter((x) => x.substr(0, 7) === 'status[' && query[x])
        .map((x) => x.substr(7).split(']')[0]);

    if (statuses.includes('open')) {
        statuses.push('unsettled');
    }

    if (statuses.includes('cancelled')) {
        statuses.push('rejected');
    }

    if (statuses.length > 0) {
        q['status'] = {
            in: statuses,
        };
    }

    // Total stake
    if (query.totalStake && (query.totalStake.start || query.totalStake.end)) {
        q['operatorTotalStake'] = {};

        if (query.totalStake.start) {
            q['operatorTotalStake'].gte = $appState.configState.precision.valueOldFormat(
                new Amount(query.totalStake.start)
            );
        }

        if (query.totalStake.end) {
            q['operatorTotalStake'].lte = $appState.configState.precision.valueOldFormat(
                new Amount(query.totalStake.end)
            );
        }
    }

    // Payout
    if (query.payoutAmount && (query.payoutAmount.start || query.payoutAmount.end)) {
        q['operatorPayout'] = {};

        if (query.payoutAmount.start) {
            q['operatorPayout'].gte = $appState.configState.precision.valueOldFormat(
                new Amount(query.payoutAmount.start)
            );
        }

        if (query.payoutAmount.end) {
            q['operatorPayout'].lte = $appState.configState.precision.valueOldFormat(
                new Amount(query.payoutAmount.end)
            );
        }
    }

    // Channel
    const channels = [];
    Object.keys(query)
        .filter((x) => x.includes('channel') && query[x])
        .map((x) =>
            x
                .slice(x.indexOf('[') + 1, x.indexOf(']'))
                .split(',')
                .forEach((x) => channels.push(x))
        );

    if (channels.length > 0) {
        q['channel'] = {
            in: channels,
        };
    }

    // Bet type
    const betTypes = Object.keys(query)
        .filter((x) => x.substr(0, 8) === 'betType[' && query[x])
        .map((x) => x.substr(8).split(']')[0]);

    if (betTypes.length > 0) {
        q['type'] = {
            in: betTypes,
        };
    }

    // Stake factor
    if (query.stakeFactor && (query.stakeFactor.start || query.stakeFactor.end)) {
        q['stakeFactor'] = {};

        if (query.stakeFactor.start) {
            q['stakeFactor'].gte = parseFloat(query.stakeFactor.start);
        }

        if (query.stakeFactor.end) {
            q['stakeFactor'].lte = parseFloat(query.stakeFactor.end);
        }
    }

    // Sports & competitions
    if (query.sport && query.sport.length) {
        let competitions = [];
        const sports = [];

        const toInt = (x) => parseInt(x, 10);

        for (const sport of query.sport) {
            if (sport.competitions === true) {
                sports.push(sport.id);
            } else if (sport.competitions.length) {
                sports.push(sport.id);
                competitions = competitions.concat(sport.competitions.map(toInt));
            }
        }

        if (sports.length > 0) {
            q['leg.sport'] = {
                in: sports,
            };
        }

        if (competitions.length > 0) {
            q['leg.competition'] = {
                in: competitions,
            };
        }
    }

    if (query.history === true) {
        const today = new Date();
        q['placedAt'] = {
            gte: getPastDateByDays(7),
            lte: today,
        };
        q['status'] = {
            in: ['open', 'parked', 'settled', 'cancelled', 'unsettled', 'rejected', 'resulted'],
        };
    }

    // TODO: UK Horse Racing?

    api.post('/bets', q, { cache: true }).then(
        ({ results, aggregations }) => {
            results = results.map((item) => {
                if (item.maxBet) {
                    item.maxBet = $appState.configState.precision.newFromOld(item.maxBet).value;
                }

                if (item.minPotentialReturns) {
                    item.minPotentialReturns = $appState.configState.precision.newFromOld(
                        item.minPotentialReturns
                    ).value;
                }

                if (item.operatorPayout) {
                    item.operatorPayout = $appState.configState.precision.newFromOld(item.operatorPayout).value;
                }

                if (item.operatorProfit) {
                    item.operatorProfit = $appState.configState.precision.newFromOld(item.operatorProfit).value;
                }

                if (item.operatorStakePerLine) {
                    item.operatorStakePerLine = $appState.configState.precision.newFromOld(
                        item.operatorStakePerLine
                    ).value;
                }

                if (item.operatorTotalStake) {
                    item.operatorTotalStake = $appState.configState.precision.newFromOld(item.operatorTotalStake).value;
                }

                if (item.payout) {
                    item.payout = $appState.configState.precision.newFromOld(item.payout).value;
                }

                if (item.potentialReturns) {
                    item.potentialReturns = $appState.configState.precision.newFromOld(item.potentialReturns).value;
                }

                if (item.profit) {
                    item.profit = $appState.configState.precision.newFromOld(item.profit).value;
                }

                if (item.stakePerLine) {
                    item.stakePerLine = $appState.configState.precision.newFromOld(item.stakePerLine).value;
                }

                if (item.totalStake) {
                    item.totalStake = $appState.configState.precision.newFromOld(item.totalStake).value;
                }

                return item;
            });

            if (aggregations.averageStake !== undefined) {
                aggregations.averageStake = $appState.configState.precision.newFromOld(aggregations.averageStake).value;
            }

            if (aggregations.totalProfitLoss !== undefined) {
                aggregations.totalProfitLoss = $appState.configState.precision.newFromOld(
                    aggregations.totalProfitLoss
                ).value;
            }

            if (aggregations.totalStake !== undefined) {
                aggregations.totalStake = $appState.configState.precision.newFromOld(aggregations.totalStake).value;
            }

            return dispatch(finish(id, results, aggregations));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}

const getPastDateByDays = (days) => new Date(Date.now() - days * 24 * 60 * 60 * 1000);
